/**
 * defa.views.RoleApplicationSnippet
 * A snippet view for RoleApplications.
 * @version 1.0.0
 */


import Snippet from '../../poppet/snippet';
import { T }   from 'defa-object';

export const RoleApplicationSnippet = Snippet.extend( {
	// ------------------------------------------------
	// Setup
	// ------------------------------------------------
	templateContext() {
		let superContext = Snippet.prototype.templateContext.call(this);
		let header = this.model.get('customer').companyName + ' | ' + this.model.get('customer').invoiceEmail;
		if(header.length > 30){
			header = header.substring(0,30) + '...'
		}

		return _.extend(superContext, {
			hasDelete: false,
			header    :header,
		});
	},
	
	// ------------------------------------------------
	// Event Handlers
	// ------------------------------------------------


	
	// ------------------------------------------------
	// Other functions
	// ------------------------------------------------
	getAdditionalHeader: function(){
		let addHeaders = this.model.get('customer').roles;
		let addHeadersString = "";
		for(let i in addHeaders){
			addHeadersString += addHeaders[i] + " ";
		}
		if(addHeadersString.length > 40){
			addHeadersString = addHeadersString.substring(0,35) + '...'
		}
		return addHeadersString;
	},
	
} );
export default RoleApplicationSnippet;